<template>
  <div class="my-manageList-dailog" v-if="show">
    <div class="my-manageList-mask" @click="close"></div>
    <div class="my-manageList-body">
      <ul class="my-manageList-list" v-if="orgManagerList&&orgManagerList.length">
        <li class="my-manageList-item" :key="item.id" v-for="item in orgManagerList"><span class="my-manageList-fl my-manageList-ellipsis2">{{item.trueName}}</span><span class="my-manageList-fr my-manageList-ellipsis">{{item.email}}</span></li>
      </ul>
      <ul class="my-manageList-list" v-else>
        <li class="my-manageList-empty">暂无管理员</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import Cookies from 'js-cookie';
  export default {
    props: ['show'],
    data () {
      return {
        activeItem:'',
        orgManagerList:[]
      }
    },
    components: {
    },
    created () {
    },
    mounted () {
      if(Cookies.get("justId")){
        this.selectOrgManager()
      }
    },
    methods: {
      close(){
        this.$emit('closeDailog')
      },
      checkItem(item){
        this.activeItem=item.id
        this.$emit('changeItem',item)
        this.$emit('closeDailog')
      },

      // POST 查询企业管理员
      selectOrgManager () {
        this.$axios
          .post(`/onelink.mdata.main.api/recruitInfo/selectOrgManager?orgId=${Cookies.get("justId")}`)
          .then(res => {
            this.$set(this,'orgManagerList',res.data)
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
</script>
<style>
  .my-manageList-dailog{
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    z-index: 999;
  }
  .my-manageList-dailog .my-manageList-mask{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
  }
  .my-manageList-dailog .my-manageList-body{
    position: relative;
    background: #fff;
    z-index: 2;
    max-height: 510px;
    overflow-y: auto;
  }
  .my-manageList-dailog .my-manageList-list{
    padding: 0 15px;
  }
  .my-manageList-dailog .my-manageList-item{
    padding: 14px 0;
    line-height: 22px;
    border-bottom: 1px solid #E6E8EB;
    clear: both;
    overflow: hidden;
  }
  .my-manageList-dailog .my-manageList-item .my-manageList-fr{
    float:right;
    color:#909399;
    text-align: right;
  }
  .my-manageList-dailog .my-manageList-item .my-manageList-fl{
    float:left;
  }
  .my-manageList-dailog  .my-manageList-list li:last-child{
    border:0;
  }
  .my-manageList-dailog .my-manageList-item .manageList-fl-active{
    font-weight: bold;
  }
  .my-manageList-dailog .my-manageList-item .my-manageList-ellipsis{
    display: inline-block;
    width: 60%;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
    text-overflow:ellipsis;
  }
  .my-manageList-dailog .my-manageList-item .my-manageList-ellipsis2{
    display: inline-block;
    width: 35%;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
    text-overflow:ellipsis;
  }
  .my-manageList-dailog .my-manageList-empty{
    text-align: center;
    margin: 40px 0;
    color:#909399;
  }
</style>


// WEBPACK FOOTER //
// src/pages/dingWorkbench/components/manageList.vue